/**
 * @author TomaszCzura ({}
 */
import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import * as siteModel from './../../model/site';
import * as blockUtils from './../../utils/BlockUtils';
import FormComponent from './../utils/FormComponent';
import Form from './../utils/Form';
import ModalDialog from './../utils/ModalDialog';
import TextInput from './../utils/TextInput';
import * as sitesApi from './../../api/sites-api';
import {isValidEmail} from '../../utils/validate-utils';
import ErrorBox from './../utils/ErrorBox';
import {getErrorDescription} from '../../utils/view-utils';
import SelectInput from './../utils/SelectInput';
import * as user from '../../model/user';
import * as site from '../../model/site';
import Checkbox from '../utils/Checkbox';
import store from '../../store';
import * as actions from '../../actions/checkins-actions';

class SiteForm extends FormComponent {
  constructor(props) {
    super(props);
    this.sendForm = this.sendForm.bind(this);
    this.validateName = this.validateName.bind(this);
    this.handleDialogHide = this.handleDialogHide.bind(this);
    this.validateContactEmail = this.validateContactEmail.bind(this);
    this.onDisconnectionNotificationChanged = this.onDisconnectionNotificationChanged.bind(this);
  }

  sendForm() {
    const validName = this.validateName();
    const validEmail = this.validateContactEmail();

    if (validEmail && validName) {
      if (this.state.id) {
        sitesApi.updateSite(this.state).then((response) => {
          this.handleSiteApiResponse(response);
        }).catch((error) => {
          this.handleSiteApiError(error);
        });
      } else {
        sitesApi.createSite(this.state).then((response) => {
          this.handleSiteApiResponse(response);
        }).catch((error) => {
          this.handleSiteApiError(error);
        });
      }

      blockUtils.blockUI();
    }
  }

  handleSiteApiResponse(response) {
    blockUtils.unblockUI();
    if (response.status !== 200) {
      window.showAlert(i18next.t('error'), response.statusText);
    } else {
      store.dispatch(actions.flipDoNotDisturbMode());
      $(`#${this.props.dialogId}`).modal('hide');
      this.props.getData();
    }
  }

  handleSiteApiError(error) {
    blockUtils.unblockUI();
    window.showAlert(i18next.t('error'), error.statusText);
  }

  initialState() {
    if (!this.props.presentedSite || this.props.presentedSite.id === null) {
      sitesApi.getNewTokenForSite().then((response) => {
        this.setState({
          token: response.data,
        });
      }).catch(() => {});
    }

    const state = this.props.presentedSite ? siteModel.toForm(this.props.presentedSite) : siteModel.defaultSite();
    state['nameError'] = '';
    state['emailError'] = '';
    state['error'] = '';
    return state;
  }

  onDisconnectionNotificationChanged(e) {
    const state = {};
    const isEnabled = e.target.checked;
    state[e.target.name] = isEnabled;
    if (!isEnabled && !this.state.contactEmail) {
      state['emailError'] = '';
    }
    this.setState(state);
  }

  validateName(name = this.state.name) {
    return this.validateRequiredField(name, i18next.t('sites.attrs.name'), 'nameError');
  }

  validateContactEmail(email = this.state.contactEmail) {
    if (email) {
      if (isValidEmail(email)) {
        this.setState({emailError: ''});
        return true;
      } else {
        this.setState({
          emailError: i18next.t('errors.invalid_format', {
            field: i18next.t('sites.attrs.contact_email'),
          }),
        });
        return false;
      }
    } else if (this.state.disconnectionNotifications) {
      this.setState({
        emailError: i18next.t('errors.is_required', {
          field: i18next.t('sites.attrs.contact_email'),
        }),
      });
      return false;
    } else {
      this.setState({
        emailError: '',
      });
      return true;
    }
  }

  handleError(errorMessage) {
    this.setState({
      error: errorMessage,
    });
  }

  handleDialogHide() {
    store.dispatch(actions.flipDoNotDisturbModeIfNeeded());
    blockUtils.unblockUI();
  }

  render() {
    const userIsSupportStaff = this.props.user ? user.userIsSupportStaff(this.props.user) : false;

    const modalTitle = this.state.id ?
      i18next.t('sites.edit', {
        id: this.state.id,
      }) : i18next.t('sites.create_new');

    const appTechnologyList = [
      {id: 'SPK', name: 'SPK'},
      {id: 'PWA', name: 'PWA'},
    ];

    return (
      <ModalDialog modalTitle={modalTitle}
        dialogId={this.props.dialogId}
        onDialogHide={this.handleDialogHide}
        onDialogShown={this.onFormShow}
        onSubmit={this.sendForm}>
        <Form>
          <ErrorBox errorMessage={getErrorDescription(this.state.error)} />

          <TextInput fieldId="name"
            labelText={i18next.t('sites.attrs.name')}
            isRequired={true}
            error={this.state.nameError}
            validate={this.validateName}
            onChange={this.onChange}
            value={this.state.name} />

          <Checkbox fieldId="monitored"
            labelText={i18next.t('sites.attrs.monitored')}
            onChange={this.onCheckboxChanged}
            value={this.state.monitored} />

          <TextInput fieldId="externalId"
            labelText={i18next.t('sites.attrs.external_id')}
            onChange={this.onChange}
            value={this.state.externalId} />

          <TextInput fieldId="projectCode"
            labelText={i18next.t('sites.attrs.project_code')}
            onChange={this.onChange}
            value={this.state.projectCode} />

          <TextInput fieldId="contactEmail"
            labelText={i18next.t('sites.attrs.contact_email')}
            isRequired={this.state.disconnectionNotifications}
            validate={this.validateContactEmail}
            error={this.state.emailError}
            onChange={this.onChange}
            value={this.state.contactEmail} />

          <SelectInput fieldId="language" labelText={i18next.t('users.attrs.language')} selected={this.state.language}
            onChange={this.onChange} values={user.UserLanguages} />

          <SelectInput fieldId="siteType" labelText={i18next.t('sites.attrs.siteType')} selected={this.state.siteType}
            onChange={this.onChange} values={site.SiteTypes} />

          <TextInput fieldId="usercontactPhone"
            labelText={i18next.t('sites.attrs.phone')}
            isRequired={false}
            onChange={this.onChange}
            value={this.state.usercontactPhone} />

          <TextInput fieldId="usercontactAddress"
            labelText={i18next.t('sites.attrs.address')}
            isRequired={false}
            onChange={this.onChange}
            value={this.state.usercontactAddress} />

          <TextInput
            fieldId="token"
            labelText={i18next.t('sites.attrs.token')}
            isRequired={false}
            isReadonly={!userIsSupportStaff}
            value={this.state.token}
          />

          <SelectInput
            fieldId="appTechnology"
            labelText={i18next.t('sites.attrs.app_technology')}
            selected={this.state.appTechnology}
            onChange={this.onChange}
            values={appTechnologyList}
            isRequired={true}
          />

          <TextInput fieldId="gatewayId"
            labelText={i18next.t('sites.attrs.gatewayId')}
            onChange={this.onChange}
            value={this.state.gatewayId} />
        </Form>
      </ModalDialog>
    );
  }
}

SiteForm.propTypes = {
  dialogId: PropTypes.string,
  presentedSite: PropTypes.object,
  error: PropTypes.any,
  user: PropTypes.object,
  getData: PropTypes.func,
};

SiteForm.defaultProps = {};

export default SiteForm;
